import axios from 'axios'
import { Message } from 'element-ui';
import { showMessage } from './status'

// 设置接口超时时间
axios.defaults.timeout = 60000;

// 请求地址，这里是动态赋值的的环境变量
// axios.defaults.baseURL = import.meta.env.VITE_BASE_API
// axios.defaults.baseURL = "/api"

axios.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem('token')
        token && (config.headers['X-Access-Token'] = token)
        //若请求方式为post，则将data参数转为JSON字符串
         //'Content-Type':'application/x-www-form-urlencoded',   // 传参方式表单
         //'Content-Type':'application/json;charset=UTF-8',
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        config.headers['product'] = 'SHULE-ASSISTANT-WEB'
        config.headers['Access-Control-Allow-Origin'] = '*'
        // if (config.method === 'POST') {
        //     config.data = JSON.stringify(config.data);
        // }
        return config
    },
    (error) => Promise.reject(error)
)

axios.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        const { response } = error 
        if(response){
            Message.error(showMessage(response.status))  // 传入响应码，匹配响应码对应信息
            return Promise.reject(response.data)
        }else{
            Message.warning('网络连接异常,请稍后再试!');
        }
    }
)


export default function request (url = '',params = {}, type = 'POST'){
    return new Promise((resolve,reject) => {
        let promise 
        url="https://pt.sxjbhyy.com"+url
        if(type.toUpperCase() === 'GET'){
            promise = axios({
                url,
                params
            })
        }else if( type.toUpperCase()=== 'POST' ){
            promise = axios({
                method:'POST',
                url,
                data:params
            })
        }else if( type.toUpperCase()=== 'DELETE' ){
            promise = axios({
                method:'DELETE',
                url
            })
        }else if( type.toUpperCase()=== 'PUT' ){
            promise = axios({
                method:'PUT',
                url,
                data:params
            })
        }
        //处理返回
        promise.then(res=>{
            resolve(res)
        }).catch(err=>{
            reject(err)
        })
    })
}




// WEBPACK FOOTER //
// ./src/utils/shuleRequest/request.js